export const navbarConfig = [
    {
        'name': 'Home',
        'url': '#home'
    },
    {
        'name': 'About',
        'url': '#about'
    },
    {
        'name': 'Framework',
        'url': '#framework'
    },
    {
        'name': 'Skills',
        'url': '#skills'
    },
    {
        'name': 'Contact',
        'url': '#contact'
    }
]

export const HeroConfig = {
    'ID': {
        'text': 'Hi, Saya seorang full stack developer tapi lebih menyukai pekerjaan back-end developer karena lebih menantang adrenalin.'
    },
    'EN': {
        'text': "Hi, I'm a full stack developer but I prefer back-end developer because it's more adrenaline-challenging"
    }
}

export const AboutConfig = {
    'ID': {
        'paragraph': 'Saya seorang full stack developer yang menekuni di bidang <b>web development</b>. Untuk pekerjaan front-end saya biasanya menggunakan framework seperti <u>tailwindcss</u>, <u>bootstrap</u>, <u>react js</u>. Sedangkan untuk pekerjaan back-end saya biasanya  menggunakan framework <u>laravel</u>. Walaupun saya memilih menjadi web developer namun saya juga belajar bahasa lain seperti <b>python</b> dan <b>shell scripting</b>. Selain seorang web developer saya juga menekuni profesi lain seperti <b>bug hunter</b> dan <b>editing foto</b>. Dampak saya menjadi bug hunter adalah ketika saya membuat project maka saya sangat geli jika web yang saya buat memiliki celah keamanan atau bug. Oleh karena itu setiap saya mengerjakan project saya selalu berusaha mengamankan web yang saya buat agar aman dari serangan user yang jahat, Walaupun project yang saya kerjakan tidak begitu penting. Tapi itu justru menyenangkan karena seperti sebuah tantangan yang bisa membangkitkan adrenalin yang luar biasa, anjayyy.',
        'service': [
            {
                'name': 'Web Developer',
                'text': 'seseorang yang bertugas membuat dan mengembangkan website. Tanggung jawab web developer adalah membangun webuah website dan memastikan performa website tetap optimal.',
                'icon': 'Code.svg'
            },
            {
                'name': 'Bug Hunter',
                'text': 'seseorang yang mencoba memasuki suatu komputer, web, atau aplikasi untuk mencari kesalahan yang terdapat pada suatu kode suatu program.',
                'icon': 'Bug.svg'
            },
            {
                'name': 'Web Scrapper',
                'text': 'sebuah cara pengambilan suatu data atau informasi tertentu dengan jumlah besar untuk nantinya digunakan dalam berbagai keperluan seperti riset, analisis dan lainnya.',
                'icon': 'World.svg'
            }
        ]
    },
    'EN': {
        'paragraph': "I'm a full stack developer working in the field of <b>web development</b>. For front-end work I usually use frameworks like <u>tailwindcss</u>, <u>bootstrap</u>, <u>ReactJS</u>. Whereas for back-end work I usually use the <u>laravel</u> framework. Even though I chose to be a web developer, I also learned other languages such as <b>python</b> and <b>shell scripting</b>. Apart from being a web developer, I also pursue other professions such as <b>bug hunter</b> and <b>editing photo</b>. The impact of me being a bug hunter is that when I make a project, I am very amused if the web that I make has security holes or bugs. Therefore, every time I work on a project, I always try to secure the web that I make so that it is safe from attacks by malicious users, Even though the project that I am working on is not that important. But it's actually fun because it's like a challenge that can generate extraordinary adrenaline, Hehee.",
        'service': [
            {
                'name': 'Web Developer',
                'text': 'someone who is in charge of creating and developing websites. The responsibility of a web developer is to build a website and ensure optimal website performance.',
                'icon': 'Code.svg'
            },
            {
                'name': 'Bug Hunter',
                'text': "someone who tries to enter a computer, web, or application to find errors in a program's code",
                'icon': 'Bug.svg'
            },
            {
                'name': 'Web Scrapper',
                'text': 'a method of taking large amounts of certain data or information for later use in various purposes such as research, analysis and others.',
                'icon': 'World.svg'
            }
        ]
    }
}

export const FrameworkConfig = {
    'ID': {
        'title': 'yang saya kuasai',
        'paragraph': 'framework adalah kerangka kerja untuk mengembangkan aplikasi berbasis website maupun desktop.',
        'framework': [
            {
                'name': 'laravel',
                'url': 'https://laravel.com',
                'text': 'framework PHP yang open-source dan berisi banyak modul dasar untuk mengoptimalkan kinerja PHP dalam pengembangan aplikasi web.',
                'icon': 'Laravel.svg',
                'color': 'red-700'
            },
            {
                'name': 'tailwind',
                'url': 'https://tailwindcss.com',
                'text': 'kerangka kerja CSS yang di dalamnya terdapat sekumpulan utility classes untuk membangun antarmuka kustom dengan cepat.',
                'icon': 'Tailwind.svg',
                'color': 'teal-400'
            },
            {
                'name': 'bootstrap',
                'text': 'https://getbootstrap.com',
                'text': 'kerangka kerja CSS yang sumber terbuka dan bebas untuk merancang situs web dan aplikasi web.',
                'icon': 'Bootstrap.svg',
                'color': 'purple-700'
            },
            {
                'name': 'react',
                'url': 'https://react.dev',
                'text': 'library javascript yang digunakan untuk membangun user ineterface yang interaktif berbasis component.',
                'icon': 'React.svg',
                'color': 'teal-400'
            }
        ]
    },
    'EN': {
        'title': 'which a control',
        'paragraph': 'framework is a framework for developing web-based and desktop-based applications.',
        'framework': [
            {
                'name': 'laravel',
                'url': 'https://laravel.com',
                'text': 'PHP is open-source and contains many basic modules to optimize PHP performance in web application development.',
                'icon': 'Laravel.svg',
                'color': 'red-700'
            },
            {
                'name': 'tailwind',
                'url': 'https://tailwindcss.com',
                'text': 'a CSS framework that includes a set of utility classes for quickly building custom interfaces.',
                'icon': 'Tailwind.svg',
                'color': 'rgb(185 28 28)'
            },
            {
                'name': 'bootstrap',
                'text': 'https://getbootstrap.com',
                'text': 'a free and open source CSS framework for designing websites and applications.',
                'icon': 'Bootstrap.svg',
                'color': 'purple-700'
            },
            {
                'name': 'react',
                'url': 'https://react.dev',
                'text': 'javascript library used to build component-based interactive user interfaces.',
                'icon': 'React.svg',
                'color': 'teal-400'
            }
        ]
    }
}

export const SkillsConfig = {
    'skiils': [
        {
            'title': 'PHP',
            'percent': '90',
        },
        {
            'title': 'JAVASCRIPT',
            'percent': '75'
        },
        {
            'title': 'CSS',
            'percent': '85'
        },
        {
            'title': 'PYTHON',
            'percent': '90'
        },
        {
            'title': 'SHELL SCRIPTING',
            'percent': '70'
        },
        {
            'title': 'LINUX',
            'percent': '90'
        },
        {
            'title': 'BUG HUNTER',
            'percent': '85'
        }
    ]
}

export const GaleryConfig = {
    'galery': [
        {
            'image': 'GaleryOne.jpg'
        },
        {
            'image': 'GaleryTwo.jpg'
        },
        {
            'image': 'GaleryThree.jpg'
        },
        {
            'image': 'GaleryFour.jpg'
        },
        {
            'image': 'GaleryFive.jpg'
        },
        {
            'image': 'GalerySix.jpg'
        }
    ]
}

export const QuotesConfig = {
    'ID': [
        {
            'name': 'Mark Zuckerberg',
            'status': 'CEO of META',
            'image': 'Mark.png',
            'quote': 'Resiko terbesar adalah ketika tidak mengambil resiko apa pun. Di dunia yang berubah sangat cepat, satu-satunya strategi yang dijamin gagal adalah tidak mengambil resiko.'
        },
        {
            'name': 'Elon Musk',
            'status': 'CEO of TESLA',
            'image': 'Elonmusk.png',
            'quote': 'Saya memilih orang yang malas untuk melakukan pekerjaan berat. Karena orang yang malas akan menemukan cara mudah untuk melakukannya.'
        },
        {
            'name': 'Bill Gates',
            'status': 'CEO of MICROSOFT',
            'image': 'Billgates.png',
            'quote': 'Jika ada suatu peluang penting kamu harus mencobanya meskipun kamu akan gagal.'
        }
    ],
    'EN': [
        {
            'name': 'Mark Zuckerberg',
            'status': 'CEO of META',
            'image': 'Mark.png',
            'quote': 'The biggest risk is not taking any risk. In a rapidly changing world, the only strategy that is guaranteed to fail is not taking risks.'
        },
        {
            'name': 'Elon Musk',
            'status': 'CEO of TESLA',
            'image': 'Elonmusk.png',
            'quote': 'I choose lazy people to do heavy work. Because lazy people will find easy ways to do it.'
        },
        {
            'name': 'Bill Gates',
            'status': 'CEO of MICROSOFT',
            'image': 'Billgates.png',
            'quote': 'If there is an important opportunity you should try it even though you will fail.'
        }
    ]
}

export const ContactConfig = {
    'service_id': 'service_opv8czu',
    'template_id': 'template_80mk137',
    'public_key': 'YsfQ6YZjnztvjtFGS',
    'alert': {
        'title': 'Success',
        'ID': {
            'message': 'Pesan berhasil terkirim!'
        },
        'EN': {
            'message': 'Message has been sent!'
        }
    },
    'alertError': {
        'title': 'Error',
        'ID': {
            'message': 'Pesan tidak terkirim!'
        },
        'EN': {
            'message': 'Message not sent!'
        }
    }
}

export const FooterConfig = {
    'ID': {
        'quote': 'Jangan takut untuk mencoba, Jika kamu tidak mencoba maka keberhasilan tidak akan sampai kepadamu. Dan jika kamu sudah mencoba namun gagal, Percayalah keberhasilan sedang dalam perjalanan untuk datang kepadamu.',
    },
    'EN': {
        'quote': "don't be afraid to try, If you don't try then success will not reach you. And if you have tried but failed, believe that success is on its way to come to you."
    },
    'sosmed': [
        {
            'name': 'Youtube',
            'url': 'https://youtube.com/rudin_engineer',
            'icon': 'Youtube.svg'
        },
        {
            'name': 'Instgram',
            'url': 'https://instagram.com/rudin_engineer',
            'icon': 'Instagram.svg'
        },
        {
            'name': 'Tiktok',
            'url': 'https://tiktok.com/@rudin_engineer',
            'icon': 'Tiktok.svg'
        },
        {
            'name': 'Github',
            'url': 'https://github.com/rudinengineer',
            'icon': 'Github.svg'
        },
        {
            'name': 'WhatsApp',
            'url': 'https://wa.me/6383851585361',
            'icon': 'Whatsapp.svg'
        }
    ],
    'link': [
        {
            'title': 'Link',
            'list': [
                {
                    'name': 'Home',
                    'url': '#home'
                },
                {
                    'name': 'About',
                    'url': '#about'
                },
                {
                    'name': 'Framework',
                    'url': '#framework'
                },
                {
                    'name': 'Clients',
                    'url': '#clients'
                }
            ]
        },
        {
            'title': 'Follow Me',
            'list': [
                {
                    'name': 'Youtube',
                    'url': 'https://youtube.com/rudin_engineer'
                },
                {
                    'name': 'Instagram',
                    'url': 'https://instagram.com/rudin_engineer'
                },
                {
                    'name': 'Github',
                    'url': 'https://github.com/rudinengineer'
                },
                {
                    'name': 'Tiktok',
                    'url': 'https://tiktok.com/@rudin_engineer'
                }
            ]
        },
        {
            'title': 'Service',
            'list': [
                {
                    'name': 'Programmer',
                    'url': '#'
                },
                {
                    'name': 'Bug Hunter',
                    'url': '#'
                },
                {
                    'name': 'Desain Grafis',
                    'url': '#'
                }
            ]
        },
        {
            'title': 'Help Center',
            'list': [
                {
                    'name': 'Help',
                    'url': '#'
                },
                {
                    'name': 'Contact',
                    'url': '#'
                },
                {
                    'name': 'FAQ',
                    'url': '#'
                }
            ]
        }
    ]
}